import { createContext } from 'react';

const TabsContext = createContext(void 0);

TabsContext.displayName = 'context(tab)';

export default TabsContext;